import React, { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class TrackingErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Tracking error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Silently fail - render children anyway, tracking is non-critical
      return this.props.children;
    }

    return this.props.children;
  }
}
